var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.$i18n.locale === 'id')?_c('Id'):_vm._e(),_c('En')],1)}
var staticRenderFns = []

export { render, staticRenderFns }